import type { FaireProductEntity } from "../../entity_types/product";

export const p_cvfekdpjam: FaireProductEntity = {
  token: "p_cvfekdpjam",
  type: "product",
  name: "4\"H 2 Piece Yunomi Tea Cups Gift Set Sakura Moon Design (1/16)",
  brandToken: "b_m8c3mbnsfa",
  brandName: "Urban Tokyo",
  imageUrl: "https://cdn.faire.com/fastly/48ca1693d72c49a9dd702d634ed97e80e9807aeb9b40bc784be24734fb8f0eb0.png",
  galleryImageUrls: [],
  priceDollars: 7,
  description: "Size: 3.3\"D x 4\"H Capacity: 10 fl oz\n\n2 Piece Set Packaging\n\nCase Pack: 16\n\nProduct Origin: China\n",
  tags: [],
  msrpDollars: 15.75,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:02:38.620Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
